var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUisses1Male(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 99,
    viewBox: "0 0 90 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4135_3904)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4135_3904",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 90,
    height: 115
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 1.65967H0.5V115.66H89.5V1.65967Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4135_3904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 40.2297C18.9998 40.2297 24.1198 45.1497 46.9498 46.1897C61.4498 45.5297 72.6898 40.3197 72.6898 40.3197C72.4098 44.2997 73.9098 55.5997 73.7598 56.9897C73.3598 57.7097 73.3598 72.3597 73.3598 72.3597L71.5098 114.66C71.5098 114.66 73.2398 114.9 63.5098 114.66C53.7798 114.42 52.0098 114.66 52.0098 114.66L46.4598 75.8897L44.1198 75.4797L39.5098 105.66L38.0098 115.43C38.0098 115.43 38.8898 115.93 26.0098 115.44C16.4598 115.08 19.1098 115.22 19.1098 115.22L18.0098 83.7497L17.5098 52.1497L19.1198 41.7897L19.0098 40.2197L18.9998 40.2297Z",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6398 -19.9199C16.8598 -18.2499 15.9398 -13.9099 16.3598 -11.0999C16.9698 -6.96992 17.5098 -3.34992 18.1598 0.070076C19.9498 9.43008 20.0198 9.33007 20.9198 16.0401C21.6598 21.5501 21.4898 24.3001 20.7398 27.4501C19.9898 30.5901 19.2898 33.5201 19.0298 38.7401C18.9698 40.0101 18.9598 40.0301 18.9998 40.7101C16.3298 51.9401 17.7698 66.7101 17.9898 84.1301C17.9898 84.1301 18.7998 109.83 18.8298 114.99",
    stroke: "#2E2E2E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1196 115.22C39.0696 107.83 39.8596 105.64 40.7296 96.9299C40.8296 90.9799 43.4396 81.3299 44.0996 75.4799C44.4196 75.6299 44.8196 75.7699 45.2996 75.8399C46.6696 76.0599 47.7896 75.6099 48.2996 75.3599",
    stroke: "#2E2E2E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.06 113.48C51.11 108.89 46.69 78.3996 46.27 75.8896",
    stroke: "#2E2E2E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8099 -21.7803C74.0199 -18.3103 73.2699 -9.47027 73.1599 -8.33027C72.1799 1.75973 72.3099 0.569727 70.7399 9.55973C69.8899 14.4297 69.0199 16.2797 69.7699 21.6897C70.3899 26.1997 71.8299 28.1397 72.4399 34.0597C72.7899 37.4597 72.7599 40.2697 72.6799 42.1097C73.0799 43.6397 72.5399 46.4197 73.0399 49.1297C74.3499 56.2297 73.4099 61.5997 73.5199 65.4597C73.5199 65.4597 71.7399 104.73 71.2599 114.99",
    stroke: "#2E2E2E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2697 -58.6401C54.7597 -54.8601 54.9497 -51.7901 55.2497 -49.9301C55.3997 -49.0301 55.7797 -48.1701 56.3997 -47.4901C57.5997 -46.1601 59.1897 -45.3101 61.0397 -44.7401C61.1197 -44.7201 61.1896 -44.6901 61.2596 -44.6601L68.9997 -41.2601C69.0497 -41.2401 69.1096 -41.2101 69.1696 -41.2001C74.6296 -39.3501 75.2697 -39.7501 77.6397 -38.5001C82.7197 -35.8201 85.2597 -26.1901 85.2597 -19.7701C85.2597 -18.4801 85.1697 -18.5101 83.4997 -8.48014C82.5897 -3.03014 81.6896 2.38986 81.3396 4.84986C79.9396 14.6999 81.5996 22.1599 82.0596 27.9899C82.7096 36.1499 83.1297 48.2099 79.3597 64.3699C79.7697 68.7699 79.0197 72.3299 79.1797 74.8099C79.3597 77.6899 78.1396 79.6899 77.9196 80.2099C76.5396 83.4699 76.4797 83.6599 75.0397 84.7999L72.5797 86.3899",
    stroke: "#2E2E2E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0399 -58.6401C35.5499 -54.8601 35.3599 -51.7901 35.0599 -49.9301C34.9099 -49.0301 34.5299 -48.1701 33.9099 -47.4901L21.8499 -41.2501C21.7999 -41.2301 21.7399 -41.2001 21.6799 -41.1901C16.4699 -39.4301 13.9899 -38.6801 12.6699 -38.2201C7.33987 -36.3601 5.27987 -26.6401 4.90987 -24.2701C4.63987 -22.5501 4.45987 -20.3501 6.26987 -8.20014C7.50987 0.109862 7.95987 1.50986 8.42987 5.12986C9.71987 14.8699 8.74987 21.8899 8.34987 26.7999C7.68987 35.0099 7.23987 47.2699 10.9499 64.3799C10.5399 68.7799 11.2899 72.3399 11.1299 74.8199C10.9499 77.6999 12.1699 79.6999 12.3899 80.2199C13.7699 83.4799 13.8299 83.6699 15.2699 84.8099L18.0499 86.3999",
    stroke: "#2E2E2E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5098 24.8199C46.3098 24.0099 47.6098 24.0099 48.4198 24.8199",
    stroke: "#2E2E2E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5498 63.2598L9.0498 100.48",
    stroke: "#2E2E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7598 63.2598L82.2598 100.48",
    stroke: "#2E2E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7197 50.8198C45.7197 50.8198 47.2997 73.3598 43.9497 75.6398",
    stroke: "#2E2E2E",
    strokeWidth: 0.23,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9598 42.5396C30.1698 47.5196 53.4098 50.1496 72.6898 42.0996V47.6596C57.2598 53.8396 38.1398 52.3196 18.0098 47.6596L18.9598 42.5396Z",
    fill: "#2E2E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9197 46.2897C56.9197 46.2897 58.7797 49.0597 58.1297 52.3497L61.0297 51.4197C61.0297 51.4197 62.2997 47.5697 60.4197 45.6997L56.9097 46.2797L56.9197 46.2897Z",
    fill: "#747474"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9896 46.2897C36.9896 46.2897 35.1296 49.3197 35.7796 52.3297L32.8796 51.4797C32.8796 51.4797 31.9996 47.4297 33.8796 45.7197L36.9896 46.2897Z",
    fill: "#747474"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3198 44.0296C23.3198 44.0296 22.0498 48.0496 22.4898 51.4496L20.5198 50.4896C20.5198 50.4896 19.9398 45.2196 21.2198 43.2896L23.3198 44.0296Z",
    fill: "#747474"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4497 43.9896C67.4497 43.9896 68.6297 46.8496 68.2197 50.2496L70.0597 49.2896C70.0597 49.2896 70.8297 45.2196 69.6397 43.2896L67.4497 43.9896Z",
    fill: "#747474"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3398 47.2695L49.1398 47.3295C49.4398 47.3295 49.4098 47.7795 49.4198 48.0295L49.5498 50.9195C49.5598 51.1795 49.5898 51.6595 49.2798 51.6695L44.4398 51.7895",
    stroke: "white",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0796 49.3894C49.0796 49.3894 50.3696 49.9394 50.9396 49.1294",
    stroke: "white",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0097 49.5097C53.1699 49.5097 53.2997 49.3799 53.2997 49.2197C53.2997 49.0595 53.1699 48.9297 53.0097 48.9297C52.8496 48.9297 52.7197 49.0595 52.7197 49.2197C52.7197 49.3799 52.8496 49.5097 53.0097 49.5097Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 49.6396C47.1201 49.6396 47.2499 49.5097 47.2499 49.3496C47.2499 49.1894 47.1201 49.0596 46.9599 49.0596C46.7998 49.0596 46.6699 49.1894 46.6699 49.3496C46.6699 49.5097 46.7998 49.6396 46.9599 49.6396Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3598 49.1396C43.52 49.1396 43.6498 49.0097 43.6498 48.8496C43.6498 48.6894 43.52 48.5596 43.3598 48.5596C43.1997 48.5596 43.0698 48.6894 43.0698 48.8496C43.0698 49.0097 43.1997 49.1396 43.3598 49.1396Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0898 49.2196C56.25 49.2196 56.3798 49.0898 56.3798 48.9296C56.3798 48.7695 56.25 48.6396 56.0898 48.6396C55.9296 48.6396 55.7998 48.7695 55.7998 48.9296C55.7998 49.0898 55.9296 49.2196 56.0898 49.2196Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7201 68.8198C25.3101 76.4898 25.3101 84.3498 25.2601 92.1198C25.3901 98.9198 25.5201 105.79 26.8601 112.48C27.0201 113.44 27.3601 114.36 27.6501 115.29C27.3201 114.42 26.9901 113.44 26.8001 112.49C25.3301 105.82 25.2101 98.9198 25.1201 92.1198C25.2101 84.3598 25.2101 76.4198 26.7201 68.8198Z",
    fill: "#2E2E2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9202 114.92C66.4202 99.2698 67.3802 83.5298 66.7902 67.7998H66.8002C67.6202 83.5098 66.5002 99.3198 64.9102 114.92H64.9202Z",
    fill: "#2E2E2E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4201 49.5698C22.3101 54.2298 20.5801 59.0398 17.3701 62.6398C20.3601 58.8198 22.2401 54.2098 23.4201 49.5698Z",
    fill: "#2E2E2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 50.6099C70.63 53.8499 72.39 58.3899 73.31 61.6199C72.09 58.4899 70.55 53.8199 69.5 50.6099Z",
    fill: "#2E2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4135_3904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUisses1Male);
export default __webpack_public_path__ + "static/media/сuisses-1-male.82e3212c65d754c35a18bfb65e93d3ef.svg";
export { ForwardRef as ReactComponent };